import TextArea from './textarea'

export type { TextAreaProps } from './textarea'

export { TextArea }
